if (!customElements.get('dieux-featured-product-showcase')) {
  class DieuxFeaturedProductShowcase extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      this.productCard = this.querySelector('[data-featured-product-card]');
      this.cardMedia = this.querySelector('[data-featured-product-card-media]');
      this.cardMeta = this.querySelector('[data-featured-product-card-meta]');
      this.variantPicker = this.querySelector('[data-variant-picker]');
      this.overlayMedia = Array.from(this.querySelectorAll('[data-featured-product-overlay-media]'));

      customElements.whenDefined('variant-picker').then(() => {
        if (!this.isConnected) return;
        this.variantPicker?.addEventListener('change', this.syncFromPicker, {
          signal: this.abortController.signal,
        });
        requestAnimationFrame(() => this.syncFeaturedVariant());
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    syncFeaturedVariant() {
      if (!(this.variantPicker instanceof HTMLElement)) return;
      if (this.dataset.featuredProductId !== this.variantPicker.dataset.productId) return;

      const requestedVariantId = this.dataset.featuredVariantId;
      if (!requestedVariantId || requestedVariantId === this.variantPicker.dataset.currentVariantId) return;
      if (this.variantPicker.selectVariantById?.(requestedVariantId)) {
        this.syncVariantFragments(requestedVariantId);
      }
    }

    syncVariantFragments(variantId) {
      customElements.whenDefined('dieux-variant-fragments').then(() => {
        if (!this.isConnected) return;

        this.querySelectorAll('dieux-variant-fragments').forEach((fragments) => {
          if (fragments.dataset.productId !== this.variantPicker?.dataset.productId) return;
          fragments.selectVariant?.(variantId);
        });
      });
    }

    syncFromPicker = (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-variant-option]')) return;

      requestAnimationFrame(() => {
        if (!(this.variantPicker instanceof HTMLElement)) return;
        const selectedVariantId = this.variantPicker.dataset.currentVariantId;
        if (!selectedVariantId || selectedVariantId === this.dataset.featuredVariantId) return;

        const variantData = this.variantPicker.querySelector('script[data-product-variants]');
        if (!variantData?.textContent) return;

        let selectedVariant;
        try {
          selectedVariant = JSON.parse(variantData.textContent).find(
            (variant) => String(variant.id) === selectedVariantId
          );
        } catch (_error) {
          return;
        }
        if (!selectedVariant) return;

        this.dataset.featuredVariantId = selectedVariantId;
        this.syncVariantFragments(selectedVariantId);

        if (this.productCard instanceof HTMLElement) {
          this.productCard.dataset.featuredProductVariantId = selectedVariantId;
        }
        const variantTitle = this.cardMeta?.querySelector('[data-featured-product-card-variant-title]');
        if (variantTitle) {
          const subtitle = selectedVariant.variantSubtitle?.trim() || '';
          variantTitle.textContent = subtitle;
          variantTitle.hidden = subtitle === '';
        }

        const findTemplate = (attribute, mediaSource) =>
          [...this.variantPicker.querySelectorAll(`template[${attribute}]`)].find(
            (template) =>
              template.dataset.variantId === selectedVariantId &&
              (!mediaSource || template.dataset.mediaSource === mediaSource)
          );

        const mediaSource = this.cardMedia?.dataset.featuredProductCardMediaSource || 'transparent';
        const mediaTemplate = findTemplate('data-variant-featured-product-media', mediaSource);
        const overlayTemplate =
          findTemplate('data-variant-featured-product-overlay-media') || mediaTemplate;

        if (this.cardMedia instanceof HTMLElement && mediaTemplate instanceof HTMLTemplateElement) {
          this.cardMedia.replaceChildren(mediaTemplate.content.cloneNode(true));
        }

        if (!(overlayTemplate instanceof HTMLTemplateElement)) return;

        this.overlayMedia.forEach((overlay) => {
          if (!(overlay instanceof HTMLElement)) return;
          const media = overlayTemplate.content.cloneNode(true);
          media.querySelectorAll?.('img').forEach((image) => image.setAttribute('alt', ''));
          overlay.replaceChildren(media);
        });
      });
    };
  }

  customElements.define('dieux-featured-product-showcase', DieuxFeaturedProductShowcase);
}
